import ShoppingCartNew from 'screens/ShoppingCartNew';

export default function ShoppingCartContainer() {
  return <ShoppingCartNew />;
}
